import {
    getJobListingRepo,
    getDepartmentsRepo,
    getUserListRepo,
    getJobBasicDetailRepo,
    getStaticContentRepo,
    putStaticContentRepo,
    postBasicJobDetailsRepo,
    getJobLocationRepo,
    putJobBasicDetailRepo,
    getApplicantListRepo,
    getApplicantFiltersRepo,
    getApplicantRepo,
    getDownloadApplicantListRepo,
    putApplicantCommentsRepo,
    getApplicantFlushDataRepo,
} from "../repositories/hiring";
import { createSlice } from "@reduxjs/toolkit";
const hiringSlice = createSlice({
    name: "hiringReducer",
    initialState: {
        jobListingLoading: false,
        jobListingData: null,
        jobListingError: null,
        departmentsListLoading: false,
        departmentsListData: null,
        departmentsListError: null,
        userListLoading: false,
        userListData: null,
        userListError: null,
        jobBasicDetailLoading: false,
        jobBasicDetailData: null,
        jobBasicDetailError: null,
        staticContentLoading: false,
        staticContent: null,
        staticContentError: null,
        putStaticContentLoading: false,
        putStaticContentData: null,
        putStaticContentError: null,
        postBasicJobDetailsData: null,
        postBasicJobDetailsError: null,
        putBasicJobDetailsData: null,
        putBasicJobDetailsError: null,
        applicantListLoading: false,
        applicantList: null,
        applicantListError: null,

        applicantDesignationFilterLoading: false,
        applicantDesignationFilter: null,
        applicantDesignationFilterError: null,

        applicantDepartmentFilterLoading: false,
        applicantDepartmentFilter: null,
        applicantDepartmentFilterError: null,

        applicantStatusFilterLoading: false,
        applicantStatusFilter: null,
        applicantStatusFilterError: null,

        applicantLoading: false,
        applicantData: null,
        applicantError: null,

        downloadApplicantListLoading: false,
        downloadApplicantList: null,
        downloadApplicantListError: null,

        putApplicantCommentsLoading: false,
        putApplicantCommentsData: null,
        putApplicantCommentsError: null,

        getApplicantDataLoading: false,
        getApplicantData: null,
        getApplicantDataError: null,
    },
    reducers: {
        getJobListingLoading(state, action) {
            return {
                ...state,
                jobListingLoading: true,
            };
        },
        getJobListingSuccess(state, action) {
            return {
                ...state,
                jobListingLoading: false,
                jobListingData: action.payload,
            };
        },
        getJobListingFailure(state, action) {
            return {
                ...state,
                jobListingLoading: false,
                jobListingError: action.payload,
            };
        },
        getDepartmentsLoading(state, action) {
            return {
                ...state,
                departmentsListLoading: true,
            };
        },
        getDepartmentsSuccess(state, action) {
            return {
                ...state,
                departmentsListLoading: false,
                departmentsListData: action.payload,
            };
        },
        getDepartmentsFailure(state, action) {
            return {
                ...state,
                departmentsListLoading: false,
                departmentsListError: action.payload,
            };
        },
        getUserListLoading(state, action) {
            return {
                ...state,
                userListLoading: true,
            };
        },
        getUserListSuccess(state, action) {
            return {
                ...state,
                userListLoading: false,
                userListData: action.payload,
            };
        },
        getUserListFailure(state, action) {
            return {
                ...state,
                userListLoading: false,
                userListError: action.payload,
            };
        },
        getJobBasicDetailLoading(state, action) {
            return {
                ...state,
                jobBasicDetailLoading: true,
            };
        },
        getJobBasicDetailSuccess(state, action) {
            return {
                ...state,
                jobBasicDetailLoading: false,
                jobBasicDetailData: action.payload,
            };
        },
        getJobBasicDetailFailure(state, action) {
            return {
                ...state,
                jobBasicDetailLoading: false,
                jobBasicDetailError: action.payload,
            };
        },
        clearJobBasicDetailResponse(state, action) {
            return {
                ...state,
                jobBasicDetailData: null
            };
        },

        getStaticContentLoading(state, action) {
            return {
                ...state,
                staticContentLoading: true,
            };
        },
        getStaticContentSuccess(state, action) {
            return {
                ...state,
                staticContentLoading: false,
                staticContent: action.payload,
            };
        },
        getStaticContentFailure(state, action) {
            return {
                ...state,
                staticContentLoading: false,
                staticContentError: action.payload,
            };
        },
        clearStaticContentResponse(state, action) {
            return {
                ...state,
                staticContent: null
            };
        },
        putStaticContentLoading(state, action) {
            return {
                ...state,
                putStaticContentLoading: true,
            };
        },
        putStaticContentSuccess(state, action) {
            return {
                ...state,
                putStaticContentLoading: false,
                putStaticContentData: action.payload,
            };
        },
        putStaticContentFailure(state, action) {
            return {
                ...state,
                putStaticContentLoading: false,
                putStaticContentError: action.payload,
            };
        },
        clearPutStaticContentResponse(state, action) {
            return {
                ...state,
                putStaticContentData: null
            };
        },
        postBasicJobDetailsSuccess(state, action) {
            return {
                ...state,
                postBasicJobDetailsData: action.payload,
            };
        },
        postBasicJobDetailsFailure(state, action) {
            return {
                ...state,
                postBasicJobDetailsError: action.payload,
            };
        },
        clearAllBasicJobDetailsResponse(state, action) {
            return {
                ...state,
                postBasicJobDetailsData: null,
                postBasicJobDetailsError: null,
                putBasicJobDetailsData: null,
                putBasicJobDetailsError: null,
            };
        },
        getJobLocationLoading(state, action) {
            return {
                ...state,
                jobLocationLoading: true,
            };
        },
        getJobLocationSuccess(state, action) {
            return {
                ...state,
                jobLocationLoading: false,
                jobLocation: action.payload,
            };
        },
        getJobLocationFailure(state, action) {
            return {
                ...state,
                jobLocationLoading: false,
                jobLocationError: action.payload,
            };
        },
        putBasicJobDetailsSuccess(state, action) {
            return {
                ...state,
                putBasicJobDetailsData: action.payload,
            };
        },
        putBasicJobDetailsFailure(state, action) {
            return {
                ...state,
                putBasicJobDetailsError: action.payload,
            };
        },
        getApplicantListLoading(state, action) {
            return {
                ...state,
                applicantListLoading: true,
            };
        },
        getApplicantListSuccess(state, action) {
            return {
                ...state,
                applicantListLoading: false,
                applicantList: action.payload,
            };
        },
        getApplicantListFailure(state, action) {
            return {
                ...state,
                applicantListLoading: false,
                applicantListError: action.payload,
            };
        },

        getApplicantDesignationFiltersLoading(state, action) {
            return {
                ...state,
                applicantDesignationFilterLoading: true,
            };
        },
        getApplicantDesignationFiltersSuccess(state, action) {
            return {
                ...state,
                applicantDesignationFilterLoading: false,
                applicantDesignationFilter: action.payload,
            };
        },
        getApplicantDesignationFiltersFailure(state, action) {
            return {
                ...state,
                applicantDesignationFilterLoading: false,
                applicantDesignationFilterError: action.payload,
            };
        },

        getApplicantDepartmentFiltersLoading(state, action) {
            return {
                ...state,
                applicantDepartmentFilterLoading: true,
            };
        },
        getApplicantDepartmentFiltersSuccess(state, action) {
            return {
                ...state,
                applicantDepartmentFilterLoading: false,
                applicantDepartmentFilter: action.payload,
            };
        },
        getApplicantDepartmentFiltersFailure(state, action) {
            return {
                ...state,
                applicantDepartmentFilterLoading: false,
                applicantDepartmentFilterError: action.payload,
            };
        },

        getApplicantStatusFiltersLoading(state, action) {
            return {
                ...state,
                applicantStatusFilterLoading: true,
            };
        },
        getApplicantStatusFiltersSuccess(state, action) {
            return {
                ...state,
                applicantStatusFilterLoading: false,
                applicantStatusFilter: action.payload,
            };
        },
        getApplicantStatusFiltersFailure(state, action) {
            return {
                ...state,
                applicantStatusFilterLoading: false,
                applicantStatusFilterError: action.payload,
            };
        },


        getApplicantLoading(state, action) {
            return {
                ...state,
                applicantLoading: true,
            };
        },
        getApplicantSuccess(state, action) {
            return {
                ...state,
                applicantLoading: false,
                applicantData: action.payload,
            };
        },
        getApplicantFailure(state, action) {
            return {
                ...state,
                applicantLoading: false,
                applicantError: action.payload,
            };
        },


        getDownloadApplicantListLoading(state, action) {
            return {
                ...state,
                downloadApplicantListLoading: true,
            };
        },
        getDownloadApplicantListSuccess(state, action) {
            return {
                ...state,
                downloadApplicantListLoading: false,
                downloadApplicantList: action.payload,
            };
        },
        getDownloadApplicantListFailure(state, action) {
            return {
                ...state,
                downloadApplicantListLoading: false,
                downloadApplicantListError: action.payload,
            };
        },
        putApplicantCommentsSuccess(state, action) {
            return {
                ...state,
                putApplicantCommentsLoading: false,
                putApplicantCommentsData: action.payload,
            };

        },
        putApplicantCommentsFailure(state, action) {
            return {
                ...state,
                putApplicantCommentsLoading: false,
                putApplicantCommentsError: action.payload,
            };
        },
        getApplicantFlushDataLoading(state, action) {
            return {
                ...state,
                getApplicantDataLoading: true,
            };
        },
        getApplicantFlushDataSuccess(state, action) {
            return {
                ...state,
                getApplicantDataLoading: false,
                getApplicantData: action.payload,
            };
        },
        getApplicantFlushDataFailure(state, action) {
            return {
                ...state,
                getApplicantDataLoading: false,
                getApplicantDataError: action.payload,
            };
        },
        clearApplicantFlushDataResponse(state, action) {
            return {
                ...state,
                getApplicantData: null,
                getApplicantDataError: null,
            };
        },
    },
});

export const {
    getJobListingLoading,
    getJobListingSuccess,
    getJobListingFailure,
    getDepartmentsLoading,
    getDepartmentsSuccess,
    getDepartmentsFailure,
    getUserListLoading,
    getUserListSuccess,
    getUserListFailure,
    getJobBasicDetailLoading,
    getJobBasicDetailSuccess,
    getJobBasicDetailFailure,
    clearJobBasicDetailResponse,
    getStaticContentLoading,
    getStaticContentSuccess,
    getStaticContentFailure,
    clearStaticContentResponse,
    putStaticContentLoading,
    putStaticContentSuccess,
    putStaticContentFailure,
    clearPutStaticContentResponse,
    postBasicJobDetailsSuccess,
    postBasicJobDetailsFailure,
    clearAllBasicJobDetailsResponse,
    getJobLocationLoading,
    getJobLocationSuccess,
    getJobLocationFailure,
    putBasicJobDetailsSuccess,
    putBasicJobDetailsFailure,
    getApplicantListLoading,
    getApplicantListSuccess,
    getApplicantListFailure,
    getApplicantDesignationFiltersLoading,
    getApplicantDesignationFiltersSuccess,
    getApplicantDesignationFiltersFailure,
    getApplicantDepartmentFiltersLoading,
    getApplicantDepartmentFiltersSuccess,
    getApplicantDepartmentFiltersFailure,
    getApplicantStatusFiltersLoading,
    getApplicantStatusFiltersSuccess,
    getApplicantStatusFiltersFailure,
    getApplicantLoading,
    getApplicantSuccess,
    getApplicantFailure,
    getDownloadApplicantListLoading,
    getDownloadApplicantListSuccess,
    getDownloadApplicantListFailure,
    putApplicantCommentsSuccess,
    putApplicantCommentsFailure,
    getApplicantFlushDataLoading,
    getApplicantFlushDataSuccess,
    getApplicantFlushDataFailure,
    clearApplicantFlushDataResponse,
} = hiringSlice.actions;

export const getJobListingList = (params) => {
    return async (dispatch) => {
        dispatch(getJobListingLoading());
        await getJobListingRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getJobListingSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getJobListingFailure(error.message));
                }
            });
    };
};

export const getDepartmentsList = (params) => {
    return async (dispatch) => {
        dispatch(getDepartmentsLoading());
        await getDepartmentsRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getDepartmentsSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getDepartmentsFailure(error.message));
                }
            });
    };
};

export const getUserList = (params) => {
    return async (dispatch) => {
        dispatch(getUserListLoading());
        await getUserListRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getUserListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getUserListFailure(error.message));
                }
            });
    };
};

export const getJobBasicDetail = (params) => {
    return async (dispatch) => {
        dispatch(getJobBasicDetailLoading());
        await getJobBasicDetailRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getJobBasicDetailSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getJobBasicDetailFailure(error.message));
                }
            });
    };
};

export const getStaticContent = (params) => {
    return async (dispatch) => {
        dispatch(getStaticContentLoading());
        await getStaticContentRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getStaticContentSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getStaticContentFailure(error.message));
                }
            });
    };
};

export const putStaticContent = (data) => {
    return async (dispatch) => {
        dispatch(putStaticContentLoading());
        await putStaticContentRepo(data)
            .then((response) => {
                if (response && response?.status == 200 ||
                    response?.status == 201) {
                    dispatch(putStaticContentSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putStaticContentFailure(error.message));
                }
            });
    };
};

export const postBasicJobDetails = (data) => {
    return async (dispatch) => {
        await postBasicJobDetailsRepo(data)
            .then((response) => {
                if (
                    response?.status == 200 ||
                    response?.status == 201 ||
                    response?.status == 302
                ) {
                    dispatch(postBasicJobDetailsSuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postBasicJobDetailsFailure(error.message));
                }
            });
    };
};

export const putBasicJobDetails = (id, data) => {
    return async (dispatch) => {
        await putJobBasicDetailRepo(id, data)
            .then((response) => {
                if (response && response?.status == 200 ||
                    response?.status == 201) {
                    dispatch(putBasicJobDetailsSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putBasicJobDetailsFailure(error.message));
                }
            });
    };
};

export const getJobLocation = (params) => {
    return async (dispatch) => {
        dispatch(getJobLocationLoading());
        await getJobLocationRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getJobLocationSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getJobLocationFailure(error.message));
                }
            });
    };
};

export const getApplicantListing = (params) => {
    return async (dispatch) => {
        dispatch(getApplicantListLoading());
        await getApplicantListRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getApplicantListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getApplicantListFailure(error.message));
                }
            });
    };
};

export const getApplicantDesignationFilters = (params) => {
    return async (dispatch) => {
        dispatch(getApplicantDesignationFiltersLoading());
        await getApplicantFiltersRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getApplicantDesignationFiltersSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getApplicantDesignationFiltersFailure(error.message));
                }
            });
    };
};

export const getApplicantDepartmentFilters = (params) => {
    return async (dispatch) => {
        dispatch(getApplicantDepartmentFiltersLoading());
        await getApplicantFiltersRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getApplicantDepartmentFiltersSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getApplicantDepartmentFiltersFailure(error.message));
                }
            });
    };
};

export const getApplicantStatusFilters = (params) => {
    return async (dispatch) => {
        dispatch(getApplicantStatusFiltersLoading());
        await getApplicantFiltersRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getApplicantStatusFiltersSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getApplicantStatusFiltersFailure(error.message));
                }
            });
    };
};

export const getApplicant = (id, params) => {
    return async (dispatch) => {
        dispatch(getApplicantLoading());
        await getApplicantRepo(id, params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getApplicantSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getApplicantFailure(error.message));
                }
            });
    };
};

export const getDownloadApplicantList = (id) => {
    return async (dispatch) => {
        dispatch(getDownloadApplicantListLoading());
        await getDownloadApplicantListRepo(id)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getDownloadApplicantListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getDownloadApplicantListFailure(error.message));
                }
            });
    };
};

export const putApplicantComments = (id, data) => {
    return async (dispatch) => {
        await putApplicantCommentsRepo(id, data)
            .then((response) => {
                if (response && response?.status == 200 ||
                    response?.status == 201) {
                    dispatch(putApplicantCommentsSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putApplicantCommentsFailure(error.message));
                }
            });
    };
};

export const getApplicantFlushData = () => {
    return async (dispatch) => {
        dispatch(getApplicantFlushDataLoading());
        await getApplicantFlushDataRepo()
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getApplicantFlushDataSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getApplicantFlushDataFailure(error.message));
                }
            });
    };
};

export default hiringSlice.reducer;

